import request from '@/utils/request';
import { datasetEndpoint } from '@/constants/urls';

const markdown = (code) => request({
  method: 'GET',
  url: `${datasetEndpoint(code)}/markdown`,
});

const DatasetMarkdownService = {
  markdown,
};

export default DatasetMarkdownService;
